import { https } from '../https';
import { ISectionsLinksDto, IStaticPageDetailDto } from './static-page.dto';

export const baseUrl = '/v1/pages';

export const staticPageData = {
  getStaticSections: async (customerId: number): Promise<ISectionsLinksDto> =>
    https.get<ISectionsLinksDto>(baseUrl, {
      headers: { 'Gtm-Customer-id': customerId },
    }),

  getStaticPage: async (id: number, customerId: number): Promise<IStaticPageDetailDto> =>
    https.get<IStaticPageDetailDto>(`${baseUrl}/${id}`, {
      headers: { 'Gtm-Customer-id': customerId },
    }),
};
